import MuiListItem, { ListItemProps } from '@mui/material/ListItem';

export interface IListItemProps extends ListItemProps {}

const ListItem = (props: IListItemProps): JSX.Element => {
  return <MuiListItem {...props} />;
};

export default ListItem;
